import script from "./ArrearsStatCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ArrearsStatCard.vue?vue&type=script&setup=true&lang=js"

import "./ArrearsStatCard.vue?vue&type=style&index=0&id=4eddc2b0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4eddc2b0"]])

export default __exports__